
import React from 'react';

const useDevolucao = (getApi) => {

    let form = null;
    const salvaDevolucao = async (formulario) => {
        form = formulario;
        
        const devolucao = preparaDevolucao();

        const api = await getApi();
        const result = await api.post('/devolucao', {devolucao});

        return result.data
        
    }

    const  preparaItens = (itens, origem) => {
        //return itens;
        return itens.map(item => {
            const {uuidProduto, uuid, unidade, credito, quantidade, codigoProduto , descricaoProduto, valorUn, qtdDevolver} = item
            return {
                uuidProduto, 
                uuidItemOrigem: uuid, 
                origem: '',
                descricaoProduto,
                codigoProduto,
                quantidade: qtdDevolver,
                unidade,
                valorUn,
                totalItem: credito,
                origem

                

            }
        })
    }

    const preparaDevolucao = () => {
        const {venda, cliente, itens, obs, valorTotalDevolvido, vendedor} = form.getFieldsValue(true);
        
        const itensPreparados = preparaItens(itens, venda.tipo);
        
        let dadosPreparados =  {
            uuidReferencia: venda.uuid,
            tipoReferencia: venda.tipo,
            
            obs,
            itens: itensPreparados,
            valorTotalDevolvido
        };

        if(cliente){
            dadosPreparados = Object.assign({}, dadosPreparados,{
                cliente: cliente.uuid,
                identificacaoCliente: cliente.nome
            });
        }

        if(vendedor) {
            dadosPreparados = Object.assign({}, dadosPreparados,{ uuidVendedor : vendedor.uuid});
        }

        return dadosPreparados



    }

    const buscarDevolucao =async (termo, de, ate)=>{
        const api = await getApi();
        
        const result = await api.get('/devolucao', {
            params: {termo, de, ate}
        });
        return result.data;
    }

    const excluirDevolucao = async (devolucao) => {
        console.log("devolucao", devolucao);
        const api = await getApi();
        const result = await api.delete('/devolucao/' + devolucao.uuid);
        return result.data;
    }


    return {salvaDevolucao, buscarDevolucao, excluirDevolucao}
}

export {useDevolucao};